function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.0004 8.17111C15.0004 3.90111 11.6871 1 8.00043 1C4.35266 1 1.00043 3.83889 1.00043 8.21778C0.533767 8.48222 0.222656 8.98 0.222656 9.55556V11.1111C0.222656 11.9667 0.922656 12.6667 1.77821 12.6667H2.55599V7.92222C2.55599 4.91222 4.99043 2.47778 8.00043 2.47778C11.0104 2.47778 13.4449 4.91222 13.4449 7.92222V13.4444H7.22266V15H13.4449C14.3004 15 15.0004 14.3 15.0004 13.4444V12.4956C15.4593 12.2544 15.7782 11.78 15.7782 11.22V9.43111C15.7782 8.88667 15.4593 8.41222 15.0004 8.17111Z",
  fill: "#E5E4EC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.66645 9.55556C6.096 9.55556 6.44423 9.20733 6.44423 8.77778C6.44423 8.34822 6.096 8 5.66645 8C5.23689 8 4.88867 8.34822 4.88867 8.77778C4.88867 9.20733 5.23689 9.55556 5.66645 9.55556Z",
  fill: "#E5E4EC"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.3344 9.55556C10.764 9.55556 11.1122 9.20733 11.1122 8.77778C11.1122 8.34822 10.764 8 10.3344 8C9.90486 8 9.55664 8.34822 9.55664 8.77778C9.55664 9.20733 9.90486 9.55556 10.3344 9.55556Z",
  fill: "#E5E4EC"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.667 7.24556C12.2937 5.0289 10.3648 3.33334 8.03925 3.33334C5.68258 3.33334 3.14702 5.28557 3.34924 8.35001C5.27036 7.56445 6.71702 5.85334 7.12925 3.7689C8.14813 5.81445 10.2404 7.22223 12.667 7.24556Z",
  fill: "#E5E4EC"
});

function SvgIconSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupport);
export default __webpack_public_path__ + "static/media/icon-support.a7aa7e60.svg";
export { ForwardRef as ReactComponent };